<template>
  <div class="pl-6">
    <div class="text-sm font-semibold text-white">
      Categories
    </div>

    <nav class="mt-8">
      <ul class="space-y-3">
        <LinkGroup
          :parent="{
            text: 'Adobe After Effects',
            link: ''
          }"
          :children="[
            {
              text: 'Adobe After Effects Templates',
              link: '/browse/after-effects-templates/'
            },
            {
              text: 'Adobe After Effects Presets',
              link: '/browse/after-effects-presets/'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'Adobe Premiere Pro',
            link: ''
          }"
          :children="[
            {
              text: 'Adobe Premiere Pro Templates',
              link: '/browse/premiere-pro-templates/'
            },
            {
              text: 'Adobe Premiere Pro Presets',
              link: '/browse/premiere-pro-presets/'
            },
            {
              text: 'MOGRTs',
              link: '/browse/motion-graphics-templates/'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'Adobe Premiere Rush',
            link: ''
          }"
          :children="[
            {
              text: 'Adobe Premiere Rush Templates',
              link: '/browse/premiere-rush-templates/'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'DaVinci Resolve',
            link: ''
          }"
          :children="[
            {
              text: 'DaVinci Resolve Templates',
              link: '/browse/davinci-resolve-templates/'
            },
            {
              text: 'DaVinci Resolve Macros',
              link: '/browse/davinci-resolve-macros/'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'Final Cut Pro',
            link: ''
          }"
          :children="[
            {
              text: 'Final Cut Pro Templates',
              link: '/browse/final-cut-pro-templates/'
            },
          ]"
        />
        <LinkGroup
          :parent="{
            text: 'Images',
            link: ''
          }"
          :children="[
            {
              text: 'Stock Photos',
              link: '/browse/stock-photos/'
            },
            {
              text: 'Graphics',
              link: '/browse/graphics/'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'Stock Audio',
            link: ''
          }"
          :children="[
            {
              text: 'Royalty Free Music',
              link: '/browse/royalty-free-music/'
            },
            {
              text: 'Sound Effects',
              link: '/browse/sound-effects/'
            },
          ]"
        />

        <LinkGroup
          :parent="{
            text: 'Stock Video',
            link: ''
          }"
          :children="[
            {
              text: 'Stock Video Footage',
              link: '/browse/stock-video/'
            },
            {
              text: 'Motion Graphics',
              link: '/browse/stock-motion-graphics/'
            },
          ]"
        />
        <li>
          <a
            href="/browse/voice-over/"
            class="footer-link"
          >Voiceover</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import LinkGroup from './link-group';

export default {
  components: {
    LinkGroup,
  },
};
</script>
